<template>
    <div class="light-color-bg position-relative question-container">
        <div>
            <HeaderResults class="w-70" :who="who"></HeaderResults>
            <BodyResults :result="result" :who="who"></BodyResults>
            <div :style="{ backgroundImage: 'url(\'/calculateur-carbone-eclore/images/resultat-ecran_tablette.png\')' }" class="tablette-background">
            </div>
            <div :style="{ backgroundImage: 'url(\'/calculateur-carbone-eclore/images/resultat-ecran_mobile.png\')' }" class="mobile-background">
            </div>
            <div class="results-right-container" :style="{ backgroundImage: 'url(' + bgResultat + ')' }">
            </div>
        </div>
        <FooterResults class="footer"></FooterResults>
    </div>
</template>
<script>
import HeaderResults from '@/components/results/HeaderResults'
import BodyResults from '@/components/results/BodyResults.vue'
import FooterResults from '@/components/results/FooterResults'
import axios from "axios";
import { uuid } from 'vue-uuid'
export default {
    data() {
        return {
            result: null,
            who: JSON.parse(sessionStorage.getItem('who')),
            bgResultat: require('@/assets/images/result.svg'),
            calculatorData: {
                provenanceVoyageur: [
                    { type: 'Locale (15km)', factor: 22.8128111363636, unite: 'FE (kgCO2)' },
                    { type: 'Proximité (50km)', factor: 54.0256222727273, unite: 'FE (kgCO2)' },
                    { type: 'Régionale (250km)', factor: 171.051244545455, unite: 'FE (kgCO2)' },
                    { type: 'Provinciale (500km)', factor: 342.102489090909, unite: 'FE (kgCO2)' },
                    { type: 'Nationale (1500km)', factor: 828.153733636364, unite: 'FE (kgCO2)' },
                    { type: 'Internationale (5000km)', factor: 2364.20497818182, unite: 'FE (kgCO2)' },
                    { type: 'Internationale+ (10000km)', factor: 4530.25622272727, unite: 'FE (kgCO2)' }
                ],
                transportVoyage: [
                    { type: 'Voiture', factor: 0.22, unite: 'kg CO2eq/m2' },
                    { type: 'VUS et pickup', factor: 0.29, unite: 'kg CO2eq/m2' },
                    { type: 'Voiture hybride branchable', factor: 0.07, unite: 'kg CO2eq/m2' },
                    { type: 'Voiture électrique', factor: 0.000001, unite: 'kg CO2eq/m2' },
                    { type: 'Moto', factor: 0.13, unite: 'kg CO2eq/m2' },
                    { type: 'Véhicule avec roulotte', factor: 0.40, unite: 'kg CO2eq/m2' },
                    { type: 'VR petite taille', factor: 0.40, unite: 'kg CO2eq/m2' },
                    { type: 'VR grande taille', factor: 0.72, unite: 'kg CO2eq/m2' },
                    { type: 'Métro', factor: 0.00007, unite: 'kg CO2eq/m2' },
                    { type: 'Autobus urbain ou interurbain', factor: 0.06, unite: 'kg CO2eq/m2' },
                    { type: 'Train', factor: 0.11, unite: 'kg CO2eq/m2' },
                    { type: 'Avion', factor: 0.228, unite: 'kg CO2eq/m2' }
                ],
                lodging: [
                    { type: 'Hôtel ou motel', factor: 4.2, unite: 'kg CO2eq/m2' },
                    { type: 'Auberge', factor: 3.2, unite: 'kg CO2eq/m2' },
                    { type: 'Maison', factor: 2.55, unite: 'kg CO2eq/m2' },
                    { type: 'Chalet', factor: 2.55, unite: 'kg CO2eq/m2' },
                    { type: 'Appartement', factor: 0.7677, unite: 'kg CO2eq/m2' },
                    { type: 'Camping', factor: 0.03, unite: 'kg CO2eq/m2' }
                ],
                alimentation: [
                    { type: 'Amateur de viande', factor: 3300, unite: 'kg CO2/personne' },
                    { type: 'Omnivore', factor: 2500, unite: 'kg CO2/personne' },
                    { type: 'Sans boeuf', factor: 1900, unite: 'kg CO2/personne' },
                    { type: 'Végétarien', factor: 1700, unite: 'kg CO2/personne' },
                    { type: 'Végane', factor: 1500, unite: 'kg CO2/personne' },
                ],
                activite: [
                    { type: 'Activités peu émettrices', factor: 1, unite: 'kg CO2eq/personne/jour' },
                    { type: 'Activités moyennement émettrices', factor: 3, unite: 'kg CO2eq/personne/jour' },
                    { type: 'Activités fortement émettrices', factor: 19, unite: 'kg CO2eq/personne/jour' },
                    { type: 'Activités très fortement émettrices', factor: 49, unite: 'kg CO2eq/personne/jour' }
                ],
                eventPortee: [
                    { type: 'Locale (15 km)', factor: 2.15, unite: 'kg CO2eq/personne/jour' },
                    { type: 'Proximité (40 km)', factor: 5.36, unite: 'kg CO2eq/personne/jour' },
                    { type: 'Régionale (150 km)', factor: 15.16, unite: 'kg CO2eq/personne/jour' },
                    { type: 'Provinciale (500 km)', factor: 41.39, unite: 'kg CO2eq/personne/jour' },
                    { type: 'Nationale (1 500 km)', factor: 107.18, unite: 'kg CO2eq/personne/jour' },
                    { type: 'Internationale (5 000 km)', factor: 305.48, unite: 'kg CO2eq/personne/jour' },
                    { type: 'Internationale + (10 000 km)', factor: 680.54, unite: 'kg CO2eq/personne/jour' },
                ],
                transportEvent: [
                    { type: 'Auto-solo', factor: 0.21, unite: 'FE (kgCO2)' },
                    { type: 'Covoiturage', factor: 0.105, unite: 'FE (kgCO2)' },
                    { type: 'Transport en commun /<br/> interurbain', factor: 0.06, unite: 'FE (kgCO2)' },
                    { type: 'Transport actif', factor: 0, unite: 'FE (kgCO2)' },
                    { type: 'Avion', factor: 0.228, unite: 'FE (kgCO2)' },
                    { type: 'Camion', factor: 0.39789, unite: 'FE (kgCO2)' }
                ],
                energies: [
                    { type: 'Essence', factor: 2.31675, prix_moyen_l: '1,801' },
                    { type: 'Diesel (kgCO2/L)', factor: 2.31575, prix_moyen: '2,1035' },
                    { type: 'Propane automobile (kgCO2/L)', factor: 1.54753, prix_moyen_l: '0,9631' },
                    { type: 'Électricité', factor: 0.0006, prix_moyen_l: '' },
                    { type: 'Gaz naturel', factor: 1.89731, prix_moyen_l: '' },
                    { type: 'Propane', factor: 1.54753, prix_moyen_l: '' },
                    { type: 'Mazout', factor: 2.78414, prix_moyen_l: '' },
                    { type: 'Diesel', factor: 2.3157, prix_moyen_l: '' },
                ],
                vehiculeType: [
                    { type: 'Sous-compacte', factor: 0.1816409225, consommation_l_100km: 7.84033333333333 },
                    { type: 'Compacte', factor: 0.178663202459016, consommation_l_100km: 7.71180327868853 },
                    { type: 'Berline', factor: 0.220170815151515, consommation_l_100km: 9.50343434343434 },
                    { type: 'VUS compact', factor: 0.206932696518987, consommation_l_100km: 8.9320253164557 },
                    { type: 'VUS grand format, pick-up ou Fourgonnette', factor: 0.294552847297297, consommation_l_100km: 12.7140540540541 },
                    { type: 'Voiture hybride branchable', factor: 0.0743076501136364, consommation_l_100km: 3.20740909090909 },
                    { type: 'Voiture électrique', factor: 0.000001, consommation_l_100km: 4.26930794518209E-05 },
                    { type: 'Moto', factor: 0.13, unite: 'kg CO2eq/m2' },
                    { type: 'Camion cargo', factor: 0.3405767296875, consommation_l_100km: 14.700625 },
                    { type: 'Camion cube', factor: 0.3978944665625, consommation_l_100km: 14.700625 },
                    { type: 'Camion 10 roues', factor: 0.723444484659091, consommation_l_100km: 26.7284090909091 },
                    { type: 'Semi-remorque', factor: 1.07903584152542, consommation_l_100km: 39.8661016949153 },
                    { type: 'Métro', factor: 0.00007, unite: 'kg CO2eq/m2' },
                    { type: 'Autobus urbain ou interurbain', factor: 0.06, unite: 'kg CO2eq/m2' },
                    { type: 'Train', factor: 0.11, unite: 'kg CO2eq/m2' },
                    { type: 'Avion', factor: 0.228, unite: 'kg CO2eq/m2' }
                ],
                residenceType: [
                    { type: 'Appartement/condo 2 1/2', factor: 35.00, unite: 'm2' },
                    { type: 'Appartement/condo 3 1/2', factor: 45.00, unite: 'm2' },
                    { type: 'Appartement/condo 4 1/2', factor: 60.00, unite: 'm2' },
                    { type: 'Appartement/condo 5 1/2', factor: 80.00, unite: 'm2' },
                    { type: 'Appartement/condo 6 1/2', factor: 100.00, unite: 'm2' },
                    { type: 'Maison (moins de 3 chambres)', factor: 130.00, unite: 'm2' },
                    { type: 'Maison (3 à 5 chambres)', factor: 200.00, unite: 'm2' },
                    { type: 'Maison (6 chambres et plus)', factor: 250.00, unite: 'm2' },
                    { type: 'Maison de luxe', factor: 350.00, unite: 'm2' }
                ],
                batiment: [
                    { type: 'Résidentiel électrique', factor: 0.15, unite: 'kg CO2eq/m2' },
                    { type: 'Énergie - Résidentiel moyen', factor: 9.33952999978999, unite: 'kg CO2 eq m2' },
                    { type: 'Construction - Résidentiel moyen', factor: 8.5, unite: 'kg CO2 eq/m2/an' },
                    { type: 'Commercial - électrique exclusivement', factor: 0, unite: 'kg CO2eq/m2' },
                    { type: 'Commerce de gros', factor: 32.0806, unite: 'kg CO2eq/m2' },
                    { type: 'Commerce de détail', factor: 34.3666, unite: 'kg CO2eq/m2' },
                    { type: 'Transport et entreposage', factor: 27.9975, unite: 'kg CO2eq/m2' },
                    { type: 'Industrie information et culturelle', factor: 47.5266, unite: 'kg CO2eq/m2' },
                    { type: 'Bureaux', factor: 19.9526, unite: 'kg CO2eq/m2' },
                    { type: 'Établissement enseignement', factor: 35.1891, unite: 'kg CO2eq/m2' },
                    { type: 'Santé et assistance sociale', factor: 69.2832, unite: 'kg CO2eq/m2' },
                    { type: 'Arts, spectacles et loisirs', factor: 40.0433, unite: 'kg CO2eq/m2' },
                    { type: 'Restauration', factor: 57.1273, unite: 'kg CO2eq/m2' },
                    { type: 'Autres services', factor: 30.8334, unite: 'kg CO2eq/m2' },
                    { type: 'Construction - commercial moyen', factor: 8.5, unite: 'kg CO2 eq/m2/an' }
                ],
                //Not used yet

                matiereResiduelleTaux: [
                    { type: 'Enfouissement', factor: 1.67, unite: 'kg CO2eq / kg' },
                    { type: 'Recyclage', factor: 0.01, unite: 'kg CO2eq / kg' },
                    { type: 'Compostage', factor: 0.03, unite: 'kg CO2eq / kg' }
                ],
                matiereResiduelleQuantite: [
                    { type: 'Déchets domestique', factor: 229, unite: 'kg/habitant' },
                    { type: 'Déchets ICI', factor: 226, unite: 'kg/habitant' },
                    { type: 'Déchets CRD', factor: 169, unite: 'kg/habitant' },
                    { type: 'Déchets totaux', factor: 716, unite: 'kg/habitant' },
                ]
            }
        }
    },
    methods: {
        calculateResults() {
            switch (JSON.parse(sessionStorage.getItem('who'))) {
                case 'Un touriste':
                    if (sessionStorage.getItem('formType') == 'simple') {
                        return this.calculateTouristSimple()
                    }
                    else if (sessionStorage.getItem('formType') == 'detaillee') {
                        return this.calculateTouristDetaille()
                    }
                    break;
                case 'Un évènement':
                    if (sessionStorage.getItem('formType') == 'simple') {
                        return this.calculateEventSimple()
                    }
                    else if (sessionStorage.getItem('formType') == 'detaillee') {
                        return this.calculateEventDetaille()
                    }
                    break;
                case 'Un citoyen':
                    if (sessionStorage.getItem('formType') == 'simple') {
                        return this.calculateCitoyenSimple()
                    }
                    else if (sessionStorage.getItem('formType') == 'detaillee') {
                        return this.calculCitoyenDetail()
                    }
                    break;
                case 'Une organisation':
                    if (sessionStorage.getItem('formType') == 'simple') {
                        return this.calculateOrganisationSimple()
                    }
                    else if (sessionStorage.getItem('formType') == 'detaillee') {
                        return this.calculateOrganisationDetail()
                    }
                    break;
                default:
                    break;
            }
        },
        getProvenance(value) {
            let factor
            if (value > 0 && value < 50) {
                factor = this.calculatorData.provenanceVoyageur[0].factor;
            } else if (value >= 50 && value < 250) {
                factor = this.calculatorData.provenanceVoyageur[1].factor;
            } else if (value >= 250 && value < 500) {
                factor = this.calculatorData.provenanceVoyageur[2].factor;
            } else if (value >= 500 && value < 1500) {
                factor = this.calculatorData.provenanceVoyageur[3].factor;
            } else if (value >= 1500 && value < 5000) {
                factor = this.calculatorData.provenanceVoyageur[4].factor;
            } else if (value >= 5000 && value < 10000) {
                factor = this.calculatorData.provenanceVoyageur[5].factor;
            } else if (value >= 10000) {
                factor = this.calculatorData.provenanceVoyageur[6].factor;
            }
            return factor
        },
        getAlimentation(key) {
            let factor
            if (key === 'Viande à chaque repas' || key === 'Viande à tous les repas') {
                factor = this.calculatorData.alimentation.find(element => element.type === 'Amateur de viande').factor
            }
            else if (key === 'Végétalien') {
                factor = this.calculatorData.alimentation.find(element => element.type === 'Végane').factor
            }
            else {
                factor = this.calculatorData.alimentation.find(element => element.type === key).factor
            }
            return factor
        },
        calculateTouristSimple() {
            let nombreAdulte = JSON.parse(sessionStorage.getItem('touristNbPerson'))['Adultes']
            let nombreEnfant = JSON.parse(sessionStorage.getItem('touristNbPerson'))['Enfants']
            let duree = JSON.parse(sessionStorage.getItem('touristNbJours'))['Jours']

            //Provenance
            let provenanceFactor = this.getProvenance(parseInt(JSON.parse(sessionStorage.getItem('touristDistanceKm'))))
            let provenanceEmissions = provenanceFactor * (nombreAdulte + nombreEnfant / 2)
            //Calcul Alimentation
            let factor = JSON.parse(sessionStorage.getItem('touristAlimentation')).factor
            let alimentationEmissions = factor / 365 * (nombreAdulte + nombreEnfant / 2) * duree
            //Calcul Activity
            let activiteFactor = JSON.parse(sessionStorage.getItem('touristActivity')).factor
            let activiteEmissions = activiteFactor * (nombreAdulte + nombreEnfant / 2) * duree

            let emissionsTotal = alimentationEmissions + activiteEmissions + provenanceEmissions

            return (emissionsTotal / 1000).toFixed(2);
        },
        calculateTouristDetaille() {
            let nombreAdulte = JSON.parse(sessionStorage.getItem('touristNbPerson'))['Adultes']
            let nombreEnfant = JSON.parse(sessionStorage.getItem('touristNbPerson'))['Enfants']
            let duree = JSON.parse(sessionStorage.getItem('touristNbJours'))['Jours']

            //1. Trajet pour atteindre votre destination et Déplacements durant votre séjour
            let trajets = JSON.parse(sessionStorage.getItem('touristDistanceKm'))
            let destinationEmissions = 0
            Object.keys(trajets).forEach(key => {
                let factor = trajets[key].factor
                let aller = trajets[key].aller * factor
                let retour = trajets[key].retour * factor
                let local = trajets[key].troisRivieres * factor

                destinationEmissions += aller + retour + local
            })
            //3. Alimentation
            let alimentation = JSON.parse(sessionStorage.getItem('touristAlimentation'))
            let totalAlimentationEmissions = 0
            Object.keys(alimentation).forEach(key => {
                let factor = alimentation[key].factor
                let alimentationEmissions = alimentation[key].percent / 100 * factor / 365 * (nombreAdulte + nombreEnfant) * duree
                totalAlimentationEmissions += alimentationEmissions
            })
            //4. Activités
            let activity = JSON.parse(sessionStorage.getItem('touristActivity'))
            let totalActivityEmissions = 0
            Object.keys(activity).forEach(key => {
                let factor = this.calculatorData.activite.find(element => element.type === key).factor
                let alimentationEmissions = factor * activity[key] / 100 * (nombreAdulte + nombreEnfant / 2) * duree
                totalActivityEmissions += alimentationEmissions
            })
            // //5. Hébergement
            let lodging = JSON.parse(sessionStorage.getItem('touristLodging'))
            let totalLodgingEmissions = 0
            Object.keys(lodging).forEach(key => {
                let factor = lodging[key].factor
                let lodgingEmissions = factor * lodging[key].temps / 100 * (duree - 1) * lodging[key].nbChambre
                totalActivityEmissions += lodgingEmissions
            })

            // return emissionsTotal
            let emissionsTotal = destinationEmissions + totalAlimentationEmissions + totalActivityEmissions + totalLodgingEmissions
            return (emissionsTotal / 1000).toFixed(2);
        },
        calculateEventSimple() {
            let evenementNbPerson = sessionStorage.getItem('evenementNbPerson')
            let evenementPortee = JSON.parse(sessionStorage.getItem('evenementPortee'))
            let emissionsTotal = evenementNbPerson * evenementPortee.factor
            return (emissionsTotal / 1000).toFixed(2);
        },
        calculateEventDetaille() {
            let duree = JSON.parse(sessionStorage.getItem('evenementDuree'))['Jours']
            //let evenementNbParticipants = sessionStorage.getItem('evenementNbParticipants')
            let evenementDistanceChoice = JSON.parse(sessionStorage.getItem('evenementDistanceChoice'))
            let evenementDistancePartnerChoice = JSON.parse(sessionStorage.getItem('evenementDistancePartnerChoice'))
            let evenementDistanceConference = JSON.parse(sessionStorage.getItem('evenementDistanceConference'))
            //Distance Moyenne
            let distanceParticipantMoyenne = 0
            let distancePartnerMoyenne = 0
            let distanceConferenceMoyenne = 0
            //Distance réelle
            let distanceParticipantReel = 0
            let distanceTravailleurReel = 0
            let distanceConferenceReel = 0
            /*Distance*/
            if (evenementDistanceChoice === "Avec la distance moyenne parcourue par personne") {
                let results = JSON.parse(sessionStorage.getItem('evenementDistanceDetailParticipants'))
                let NbPersonne = results['Nombre de personnes']
                let AvgDistance = results['Distance moyenne']
                distanceParticipantMoyenne = this.calculateAvg(NbPersonne, AvgDistance, results);
                console.log(distanceParticipantMoyenne)
            }
            else if (evenementDistanceChoice === "Avec les distances réelles cumulées parcourues par votre public") {
                let evenementDistanceDetailParticipantsReel = JSON.parse(sessionStorage.getItem('evenementDistanceDetailParticipantsReel'))
                distanceParticipantReel = this.calculateDistanceReel(evenementDistanceDetailParticipantsReel)
            }
            if (evenementDistancePartnerChoice === "Avec la distance moyenne parcourue par personne") {
                let results = JSON.parse(sessionStorage.getItem('evenementDistanceDetailTravailleurs'))
                let NbPersonne = results['Nombre de personnes total qui travaillent pour l’évènement']
                let AvgDistance = results['Distance moyenne']
                distancePartnerMoyenne = this.calculateAvg(NbPersonne, AvgDistance, results);
                console.log(distancePartnerMoyenne)

            }
            else if (evenementDistancePartnerChoice === "Avec les distances réelles cumulées de l'organisation") {
                let evenementDistanceDetailTravailleursReel = JSON.parse(sessionStorage.getItem('evenementDistanceDetailTravailleursReel'))
                distanceTravailleurReel = this.calculateDistanceReel(evenementDistanceDetailTravailleursReel)
            }
            if (evenementDistanceConference === "Avec la distance moyenne parcourue par personne") {
                let results = JSON.parse(sessionStorage.getItem('evenementDistanceDetailPrestation'))
                let NbPersonne = results['Nombre de personnes invitées à offrir une prestation']
                let AvgDistance = results['Distance moyenne']
                distanceConferenceMoyenne = this.calculateAvg(NbPersonne, AvgDistance, results);
                console.log(distanceConferenceMoyenne)
            }
            else if (evenementDistanceConference === "Avec les distances réelles cumulées parcourues par vos invités") {
                let evenementDistanceDetailPrestationReel = JSON.parse(sessionStorage.getItem('evenementDistanceDetailPrestationReel'))
                distanceConferenceReel = this.calculateDistanceReel(evenementDistanceDetailPrestationReel)
            }
            /*Source d'énergie*/
            let evenementConsommationEnergetique = JSON.parse(sessionStorage.getItem('evenementConsommationEnergetique'))
            let evenementTypeLieu = JSON.parse(sessionStorage.getItem('evenementTypeLieu'))
            let superficie = JSON.parse(sessionStorage.getItem('superficie'))
            let consommationEnergetiqueHydro = JSON.parse(sessionStorage.getItem('consommationEnergetiqueHydro'))
            let gesSourceEnergie = 0
            if (evenementConsommationEnergetique === 'Oui') {
                let energyData = JSON.parse(sessionStorage.getItem('consommationEnergetiqueData'))
                Object.keys(energyData).forEach(key => {
                    let factor = this.calculatorData.energies.find(element => element.type == key).factor
                    gesSourceEnergie += energyData[key] * factor
                })
            }
            else if (evenementConsommationEnergetique === 'Non') {
                let factorConso = 0
                if (consommationEnergetiqueHydro == 'Oui') {
                    factorConso = 0.01
                }
                else if (consommationEnergetiqueHydro == 'Non') {
                    factorConso = 1
                }
                let factorTypeLieu = 0
                if (evenementTypeLieu == "Une salle accueillant des évènements d’arts, de spectacles et de loisirs") {
                    factorTypeLieu = 40.0433
                }
                else if (evenementTypeLieu == "Un établissement de restauration ou d’hôtellerie") {
                    factorTypeLieu = 57.1273
                }
                gesSourceEnergie = factorConso * factorTypeLieu / 365 * this.convertUnit(superficie.number, superficie.type.value) * duree
            }
            let emissionsTotal = distanceParticipantMoyenne + distancePartnerMoyenne + distanceConferenceMoyenne + distanceParticipantReel + distanceTravailleurReel + distanceConferenceReel + gesSourceEnergie
            return (emissionsTotal / 1000).toFixed(2);
        },
        calculateCitoyenSimple() {
            let nbPersons = JSON.parse(sessionStorage.getItem('citoyenNbPerson'))['Adultes']
            let nbEnfants = JSON.parse(sessionStorage.getItem('citoyenNbPerson'))['Enfants']
            let nbMonth = JSON.parse(sessionStorage.getItem('nbMonth'))
            let profilConsommateur = JSON.parse(sessionStorage.getItem('profilConsommateur'))
            let emissionsTotal = 0

            emissionsTotal = profilConsommateur.factor / 12 * nbMonth * (nbPersons + 0.5 * nbEnfants)
            
            return (emissionsTotal / 1000).toFixed(2);
        },
        calculCitoyenDetail() {
            let nbPersons = JSON.parse(sessionStorage.getItem('citoyenNbPerson'))

            // //Transports quotidiens
            let citoyenTransport = JSON.parse(sessionStorage.getItem('citoyenTransport'))
            let transportsQuotidiensEmissions = 0
            Object.keys(citoyenTransport).forEach(element => {
                if(element!=='factor'){
                    let factor = citoyenTransport.factor[element]
                    let gesTransport = citoyenTransport[element] * factor
                    transportsQuotidiensEmissions += gesTransport
                }

            })
            // //Voyages
            let citoyenTransportVoyage = JSON.parse(sessionStorage.getItem('citoyenTransportVoyage'))
            let transportsVoyagesEmissions = 0
            Object.keys(citoyenTransportVoyage).forEach(element => {
                if(element!=='factor'){
                    let factor = citoyenTransportVoyage.factor[element]
                    let gesTransport = citoyenTransportVoyage[element] * factor
                    transportsVoyagesEmissions += gesTransport
                }
            })
            // //Habitation
            let residenceType = JSON.parse(sessionStorage.getItem('residenceType'))
            let energyType = JSON.parse(sessionStorage.getItem('energyType'))
            let gesMaison = 0
            let superficie = residenceType.factor
            gesMaison += superficie * 8.5
            gesMaison += (superficie * energyType.factor)

            //Alimentation
            let citoyenAlimentation = JSON.parse(sessionStorage.getItem('citoyenAlimentation'))
            let totalAlimentationEmissions = 0
            Object.keys(citoyenAlimentation).forEach(key => {
                let factor = citoyenAlimentation[key].factor

                let alimentationEmissions = citoyenAlimentation[key].percent / 100 * factor
                totalAlimentationEmissions += alimentationEmissions
            })
            totalAlimentationEmissions = totalAlimentationEmissions * (nbPersons.Adultes + (nbPersons.Enfants / 2))

            //Déchets
            let citoyenTrash = JSON.parse(sessionStorage.getItem('citoyenTrash'))

            let totalDechetEmission = (1 + (citoyenTrash['recycling'].factor + citoyenTrash['compost'].factor + citoyenTrash['zeroDechet'].factor)) * 229 * 1.67 * (nbPersons.Adultes + (nbPersons.Enfants / 2))

            let emissionsTotal = transportsQuotidiensEmissions + transportsVoyagesEmissions + gesMaison + totalAlimentationEmissions + totalDechetEmission
            return (emissionsTotal / 1000).toFixed(2);

        },
        calculateOrganisationSimple() {
            //Transport
            let transportEmission = 0
            let organisationCarburant = JSON.parse(sessionStorage.getItem('organisationCarburant'))
            let organisationBillets = JSON.parse(sessionStorage.getItem('organisationBillets'))
            if(organisationCarburant.Essence){
                transportEmission += organisationCarburant.Essence / 1.801 * 2.31675
            }
            if(organisationCarburant.Diesel){
                transportEmission += organisationCarburant.Diesel / 2.1035 * 2.70665
            }
            if(organisationBillets['Train et autobus']){
                transportEmission += organisationBillets['Train et autobus'] / 0.204 * 0.06
            }
            if(organisationBillets.Avion){
                transportEmission += organisationBillets.Avion / 0.166 * 0.12 * 1.9
            }
                console.log(transportEmission)

            //Bâtiment
            let organisationType = JSON.parse(sessionStorage.getItem('organisationType'))
            let organisationSuperficie = JSON.parse(sessionStorage.getItem('organisationSuperficie'))
            let organisationFactor = organisationType.factor
            let batimentEmission = organisationFactor * this.convertUnit(organisationSuperficie.number, organisationSuperficie.type.value) + organisationSuperficie.number * 8.5
            let emissionsTotal = transportEmission + batimentEmission

            return (emissionsTotal / 1000).toFixed(2);
        },
        calculateOrganisationDetail() {
            //Transport
            let transportEmission = 0
            let organisationFlotteChoice = JSON.parse(sessionStorage.getItem('organisationFlotteChoice'))
            let organisationDistanceChoice = JSON.parse(sessionStorage.getItem('organisationDistanceChoice'))
            let organisationVehiculePerso = JSON.parse(sessionStorage.getItem('organisationVehiculePerso'))
            let organisationTransportCommun = JSON.parse(sessionStorage.getItem('organisationTransportCommun'))
            if (organisationFlotteChoice === "Oui") {
                if (organisationDistanceChoice === 'Selon les distances parcourues (km)') {
                    let organisationDistanceVehicule = JSON.parse(sessionStorage.getItem('organisationDistanceVehicule'))
                    transportEmission += this.calculateDistanceReelOrganisation(organisationDistanceVehicule)
                }
                else if (organisationDistanceChoice === 'Selon les dépenses ($) en carburant') {
                    let organisationDepensesCarburant = JSON.parse(sessionStorage.getItem('organisationDepensesCarburant'))
                    if(organisationDepensesCarburant){
                        if( organisationDepensesCarburant['Véhicules légers'] ){
                            transportEmission += organisationDepensesCarburant['Véhicules légers'] / 1.801 * 2.31675
                        }
                        if(organisationDepensesCarburant['Véhicules lourds']){
                            transportEmission += organisationDepensesCarburant['Véhicules lourds'] / 2.1035 * 2.70665
                        }
                    }
                }
            }
            if (organisationVehiculePerso === "Oui") {
                let organisationVehiculePersoDistance = JSON.parse(sessionStorage.getItem('organisationVehiculePersoDistance'))
                transportEmission += this.calculateDistanceReelOrganisation(organisationVehiculePersoDistance)
            }
            if (organisationTransportCommun == "Oui") {
                let organisationTransportCommunDistance = JSON.parse(sessionStorage.getItem('organisationTransportCommunDistance'))
                transportEmission += this.calculateDistanceReelOrganisation(organisationTransportCommunDistance)
            }
            //Bâtiment
            let organisationEnergie = JSON.parse(sessionStorage.getItem('organisationEnergie'))
            let batimentEmission = 0
            Object.keys(organisationEnergie).forEach(element => {
                let factor = this.calculatorData.energies.find(i => i.type === element).factor
                let gesBatiment = organisationEnergie[element] * factor
                batimentEmission += gesBatiment
            })
            let emissionsTotal = transportEmission + batimentEmission

            return (emissionsTotal / 1000).toFixed(2);
        },
        calculateAvg(nbPerson, avgDistance, values) {
            let avgFactor = 0
            Object.keys(values).forEach(key => {
                let factor = null
                if (this.calculatorData.transportEvent.find(element => element.type == key)) {
                    factor = this.calculatorData.transportEvent.find(element => element.type == key).factor
                    avgFactor += values[key] / 100 * factor
                    console.log(values[key] / 100 * factor)
                }
            })
            let distance = nbPerson * avgDistance * 2 * avgFactor

            return distance
        },
        calculateDistanceReel(value) {
            let distance = 0
            Object.keys(value).forEach(key => {
                let factor = this.calculatorData.transportEvent.find(element => element.type == key).factor
                let ges = value[key] * factor
                distance += ges
            })
            return distance
        },
        calculateDistanceReelOrganisation(value) {
            let distance = 0
            Object.keys(value).forEach(key => {
                if(key!=='factor'){
                    let factor = value['factor'][key]
                    let ges = value[key] * factor
                    distance += ges
                }
            })
            return distance
        },
        sendData() {
            if (!sessionStorage.getItem('uuid')) {
                let uuidForm = uuid.v4()
                let body = {
                    "uuid": uuidForm,
                    "qui_etes-vous": JSON.parse(sessionStorage.getItem('who')),
                    "type_de_calcul": sessionStorage.getItem('formType'),
                    "resultat": this.result
                }
                if (JSON.parse(sessionStorage.getItem('who')) === 'Un touriste') {
                    body['touriste'] = {}
                    body['touriste']["combien_adultes"] = JSON.parse(sessionStorage.getItem('touristNbPerson'))['Adultes']
                    body['touriste']["combien_enfants"] = JSON.parse(sessionStorage.getItem('touristNbPerson'))['Enfants']
                    if (body['type_de_calcul'] === 'simple') {
                        body['touriste']["duree_voyage"] = JSON.parse(sessionStorage.getItem('touristNbJours'))['Jours']
                        body['touriste']["point_de_depart"] = null
                        body['touriste']["distance_allee-retour"] = JSON.parse(sessionStorage.getItem('touristDistanceKm'))
                        body['touriste']["profil_alimentaire_simple"] = JSON.parse(sessionStorage.getItem('touristAlimentation'))
                        body['touriste']["type_activite"] = JSON.parse(sessionStorage.getItem('touristActivity'))
                    }
                    else if (body['type_de_calcul'] === 'detaillee') {
                        let touristDistanceKm = JSON.parse(sessionStorage.getItem('touristDistanceKm'))
                        let distance_detaillee = []
                        Object.keys(touristDistanceKm).forEach(element => {
                            let single_distance_detaillee = {
                                "type_de_transport": element,
                                "distance_aller": touristDistanceKm[element]['aller'],
                                "distance_retour": touristDistanceKm[element]['retour'],
                                "distance_trois-rivieres": touristDistanceKm[element]['troisRivieres'],
                            }
                            distance_detaillee.push(single_distance_detaillee)
                        })
                        body['touriste']["distance_detaillee"] = distance_detaillee
                        let lodging = JSON.parse(sessionStorage.getItem('touristLodging'))
                        let hebergement_detaille = []
                        Object.keys(lodging).forEach(element => {
                            let single_hebergement_detaille = {
                                "type_hebergement": element,
                                "temps_pourcentage": lodging[element]['temps'],
                                "nombre_chambre": lodging[element]['nbChambre'],
                            }
                            hebergement_detaille.push(single_hebergement_detaille)
                        })
                        body['touriste']["hebergement_detaille"] = hebergement_detaille
                        let alimentation = JSON.parse(sessionStorage.getItem('touristAlimentation'))
                        let alimentation_detaillee = []
                        Object.keys(alimentation).forEach(element => {
                            let single_alimentation_detaillee = {
                                "type_alimentation": element,
                                "pourcentage_alimentation": alimentation[element],
                            }
                            alimentation_detaillee.push(single_alimentation_detaillee)
                        })
                        body['touriste']["alimentation_detaillee"] = alimentation_detaillee

                        let touristActivity = JSON.parse(sessionStorage.getItem('touristActivity'))
                        let activite_detaillee = []
                        Object.keys(touristActivity).forEach(element => {
                            let single_activite_detaillee = {
                                "activite_type": element,
                                "activite_pourcentage": touristActivity[element],
                            }
                            activite_detaillee.push(single_activite_detaillee)
                        })
                        body['touriste']["activite_detaillee"] = activite_detaillee
                    }
                }
                if (JSON.parse(sessionStorage.getItem('who')) === 'Un évènement') {
                    body['evenement'] = {}
                
                    if (body['type_de_calcul'] === 'simple') {
                        body['evenement']["participants"] = sessionStorage.getItem('evenementNbPerson')
                        body['evenement']["portee"] = JSON.parse(sessionStorage.getItem('evenementPortee'))
                    }
                    else if (body['type_de_calcul'] === 'detaillee') {
                        body['evenement']["duree"] = JSON.parse(sessionStorage.getItem('evenementDuree')).Jours
                        body['evenement']["participants"] = sessionStorage.getItem('evenementNbParticipants')
                        if (sessionStorage.getItem('evenementDistanceChoice') === "Avec la distance moyenne parcourue par personne") {
                            let evenementDistanceDetailParticipants = JSON.parse(sessionStorage.getItem('evenementDistanceDetailParticipants'))
                            let pourcentage_par_vehicules = []
                            Object.keys(evenementDistanceDetailParticipants).forEach(element => {
                                if(element!=='Nombre de personnes' && element!=='Distance moyenne'){
                                    let single_pourcentage_par_vehicules = {
                                        "type_de_vehicule": element,
                                        "pourcentage": evenementDistanceDetailParticipants[element]
                                    }
                                    pourcentage_par_vehicules.push(single_pourcentage_par_vehicules)
                                }
                            })
                            body['evenement']["distance_detaille_moyenne_public"] = {
                                'nombre_de_personne':evenementDistanceDetailParticipants['Nombre de personnes'],
                                'distance_moyenne':evenementDistanceDetailParticipants['Distance moyenne'],
                                'pourcentage_par_vehicules':pourcentage_par_vehicules
                            }
                        }
                        else if (sessionStorage.getItem('evenementDistanceChoice') === "Avec les distances réelles parcourues par votre public") {
                            let evenementDistanceDetailParticipantsReel = JSON.parse(sessionStorage.getItem('evenementDistanceDetailParticipantsReel'))
                            let distance_detaillee_reelle_public = []
                            Object.keys(evenementDistanceDetailParticipantsReel).forEach(element => {
                                let single_distance_detaillee_reelle_public = {
                                    "type_de_vehicule": element,
                                    "pourcentage": evenementDistanceDetailParticipantsReel[element]
                                }
                                distance_detaillee_reelle_public.push(single_distance_detaillee_reelle_public)
                            })
                            body['evenement']["distance_detaillee_reelle_public"] = distance_detaillee_reelle_public
                        }
                        if (JSON.parse(sessionStorage.getItem('evenementDistancePartnerChoice')) === "Avec la distance moyenne parcourue par personne") {
                            let evenementDistanceDetailTravailleurs = JSON.parse(sessionStorage.getItem('evenementDistanceDetailTravailleurs'))
                            let pourcentage_par_vehicules = []
                            Object.keys(evenementDistanceDetailTravailleurs).forEach(element => {
                                if(element!=='Nombre de personnes total qui travaillent pour l’évènement' && element!=='Distance moyenne'){
                                    let single_pourcentage_par_vehicules = {
                                        "type_de_vehicule": element,
                                        "pourcentage": evenementDistanceDetailTravailleurs[element]
                                    }
                                    pourcentage_par_vehicules.push(single_pourcentage_par_vehicules)
                                }
                            })
                            body['evenement']["distance_detaille_moyenne_travaille"] = {
                                'nombre_de_personne':evenementDistanceDetailTravailleurs['Nombre de personnes total qui travaillent pour l’évènement'],
                                'distance_moyenne':evenementDistanceDetailTravailleurs['Distance moyenne'],
                                'pourcentage_par_vehicules':pourcentage_par_vehicules
                            }
                        }
                        else if (JSON.parse(sessionStorage.getItem('evenementDistancePartnerChoice')) === "Avec les distances réelles parcourues par toutes les personnes") {
                            let evenementDistanceDetailTravailleursReel = JSON.parse(sessionStorage.getItem('evenementDistanceDetailTravailleursReel'))
                            let distance_detaillee_reelle_travaille = []
                            Object.keys(evenementDistanceDetailTravailleursReel).forEach(element => {
                                let single_distance_detaillee_reelle_travaille = {
                                    "type_de_vehicule": element,
                                    "pourcentage": evenementDistanceDetailTravailleursReel[element]
                                }
                                distance_detaillee_reelle_travaille.push(single_distance_detaillee_reelle_travaille)
                            })
                            body['evenement']["distance_detaillee_reelle_travaille"] = distance_detaillee_reelle_travaille
                        }
                        if (JSON.parse(sessionStorage.getItem('evenementDistanceConference')) === "Avec la distance moyenne parcourue par personne") {
                            let evenementDistanceDetailPrestation = JSON.parse(sessionStorage.getItem('evenementDistanceDetailPrestation'))
                            let pourcentage_par_vehicules = []
                            Object.keys(evenementDistanceDetailPrestation).forEach(element => {
                                if(element!=='Nombre de personnes invitées à offrir une prestation' && element!=='Distance moyenne'){
                                    let single_pourcentage_par_vehicules = {
                                        "type_de_vehicule": element,
                                        "pourcentage": evenementDistanceDetailPrestation[element]
                                    }
                                    pourcentage_par_vehicules.push(single_pourcentage_par_vehicules)
                                }
                            })
                            body['evenement']["distance_detaille_moyenne_prestation"] = {
                                'nombre_de_personne':evenementDistanceDetailPrestation['Nombre de personnes invitées à offrir une prestation'],
                                'distance_moyenne':evenementDistanceDetailPrestation['Distance moyenne'],
                                'pourcentage_par_vehicules':pourcentage_par_vehicules
                            }
                        }
                        else if (JSON.parse(sessionStorage.getItem('evenementDistanceConference'))  === "Avec les distances réelles parcourues par toutes les personnes") {
                            let evenementDistanceDetailPrestationReel = JSON.parse(sessionStorage.getItem('evenementDistanceDetailPrestationReel'))
                            let distance_detaillee_reelle_prestation = []
                            Object.keys(evenementDistanceDetailPrestationReel).forEach(element => {
                                let single_distance_detaillee_reelle_prestation = {
                                    "type_de_vehicule": element,
                                    "pourcentage": evenementDistanceDetailPrestationReel[element]
                                }
                                distance_detaillee_reelle_prestation.push(single_distance_detaillee_reelle_prestation)
                            })
                            body['evenement']["distance_detaillee_reelle_prestation"] = distance_detaillee_reelle_prestation
                        }
                        if (JSON.parse(sessionStorage.getItem('evenementConsommationEnergetique')) === 'Oui') {

                            let consommationEnergetiqueData = JSON.parse(sessionStorage.getItem('consommationEnergetiqueData'))
                            let consommation_energetique = []
                            Object.keys(consommationEnergetiqueData).forEach(element => {
                                let single_consommation_energetique = {
                                    "type_energie": element,
                                    "energie_quantite": consommationEnergetiqueData[element]
                                }
                                consommation_energetique.push(single_consommation_energetique)
                            })
                            body['evenement']["consommation_energetique"] = consommation_energetique
                        }
                        else {
                            body['evenement']["hydro_seulement"]=JSON.parse(sessionStorage.getItem('consommationEnergetiqueHydro'))
                            body['evenement']["type_lieu"]=JSON.parse(sessionStorage.getItem('evenementTypeLieu'))
                            body['evenement']["superficie_unite"]=JSON.parse(sessionStorage.getItem('superficie')).type
                            body['evenement']["superficie_quantite"]=JSON.parse(sessionStorage.getItem('superficie')).number
                        }
                    }
                }
                if (JSON.parse(sessionStorage.getItem('who')) === 'Un citoyen') {
                    body['citoyen'] = {}
                    body['citoyen']["nombre_adulte"] = JSON.parse(sessionStorage.getItem('citoyenNbPerson'))['Adultes']
                    body['citoyen']["periode"] = JSON.parse(sessionStorage.getItem('nbMonth'))
                    if (body['type_de_calcul'] === 'simple') {

                        body['citoyen']["profil_de_consommateur"] = JSON.parse(sessionStorage.getItem('profilConsommateur'))
                    }
                    else if (body['type_de_calcul'] === 'detaillee') {
                        body['citoyen']["nombre_adulte"] = JSON.parse(sessionStorage.getItem('citoyenNbPerson'))['enfants']
                        let citoyenTransport = JSON.parse(sessionStorage.getItem('citoyenTransport'))
                        let deplacement_menage = []
                        Object.keys(citoyenTransport).forEach(element => {
                            let single_deplacement_menage = {
                                "type_de_vehicule": element,
                                "distance_menage": citoyenTransport[element],
                            }
                            deplacement_menage.push(single_deplacement_menage)
                        })
                        body['citoyen']["deplacement_menage"] = deplacement_menage

                        let citoyenTransportVoyage = JSON.parse(sessionStorage.getItem('citoyenTransportVoyage'))
                        let deplacement_voyage = []
                        Object.keys(citoyenTransportVoyage).forEach(element => {
                            let single_deplacement_voyage = {
                                "type_de_vehicule": element,
                                "distance_voyage": citoyenTransportVoyage[element],
                            }
                            deplacement_voyage.push(single_deplacement_voyage)
                        })
                        body['citoyen']["deplacement_voyage"] = deplacement_voyage
                        body['citoyen']["type_residence"] = JSON.parse(sessionStorage.getItem('residenceType'))
                        body['citoyen']["source_energie"] = JSON.parse(sessionStorage.getItem('energyType'))
                        let citoyenAlimentation = JSON.parse(sessionStorage.getItem('citoyenAlimentation'))
                        let alimentation_detaillee = []
                        Object.keys(citoyenAlimentation).forEach(element => {
                            let single_alimentation_detaillee = {
                                "type_alimentation": element,
                                "pourcentage_alimentation": citoyenAlimentation[element],
                            }
                            alimentation_detaillee.push(single_alimentation_detaillee)
                        })
                        body['citoyen']["alimentation_detaillee"] = alimentation_detaillee
                        let citoyenTrash = JSON.parse(sessionStorage.getItem('citoyenTrash'))
                        body['citoyen']["recyclez-vous"] = citoyenTrash.recycling
                        body['citoyen']["compostez-vous"] = citoyenTrash.compost
                        body['citoyen']["zero_dechet"] = citoyenTrash.zeroDechet
                    }
                }
                if (JSON.parse(sessionStorage.getItem('who')) === 'Une organisation') {
                    body['organisations'] = {}
                    body['organisations']["domaine_activite"] = JSON.parse(sessionStorage.getItem('organisationType'))
                    if (body['type_de_calcul'] === 'simple') {
                        body['organisations']["depense_essence"] = JSON.parse(sessionStorage.getItem('organisationCarburant'))['Essence']
                        body['organisations']["depense_diesel"] = JSON.parse(sessionStorage.getItem('organisationCarburant'))['Diesel']
                        body['organisations']["depense_billet_avion"] = JSON.parse(sessionStorage.getItem('organisationBillets'))['Avion']
                        body['organisations']["depense_billet_train_autobu"] = JSON.parse(sessionStorage.getItem('organisationBillets'))['Train et autobus']
                        body['organisations']["superficie_locaux"] = JSON.parse(sessionStorage.getItem('organisationSuperficie'))['number']
                        body['organisations']["unite_superficie_locaux"] = JSON.parse(sessionStorage.getItem('organisationSuperficie'))['type']
                    }
                    else if (body['type_de_calcul'] === 'detaillee') {
                        body['organisations']["flotte_vehicule"] = sessionStorage.getItem('organisationFlotteChoice')
                        if(sessionStorage.getItem('organisationDistanceChoice')==="Selon les distances parcourues (km)"){
                            let organisationDistanceVehicule = JSON.parse(sessionStorage.getItem('organisationDistanceVehicule'))
                            let distance_parcourue = []
                            Object.keys(organisationDistanceVehicule).forEach(element => {
                                let single_distance_parcourue = {
                                    "type_de_vehicule": element,
                                    "distance": organisationDistanceVehicule[element]
                                }
                                distance_parcourue.push(single_distance_parcourue)
                            })
                            body['organisations']["distance_parcourue"] = distance_parcourue
                        }
                        else if (JSON.parse(sessionStorage.getItem('organisationDepensesCarburant'))=== 'Selon les dépenses ($) en carburant'){
                            body['organisations']["depense_vehicules_legers"] = JSON.parse(sessionStorage.getItem('organisationDepensesCarburant'))['Véhicules légers']
                            body['organisations']["depense_vehicules_lourds"] = JSON.parse(sessionStorage.getItem('organisationDepensesCarburant'))['Véhicules lourds'] 
                        }
                        body['organisations']["vehicule_personnel"] = sessionStorage.getItem('organisationVehiculePerso')
                        if(sessionStorage.getItem('organisationVehiculePerso')==='Oui'){
                            let organisationVehiculePersoDistance = JSON.parse(sessionStorage.getItem('organisationVehiculePersoDistance'))
                            let distance_vehicule_personnel = []
                            Object.keys(organisationVehiculePersoDistance).forEach(element => {
                                let single_distance_vehicule_personnel= {
                                    "type_de_vehicule": element,
                                    "distance": organisationVehiculePersoDistance[element]
                                }
                                distance_vehicule_personnel.push(single_distance_vehicule_personnel)
                            })
                            body['organisations']["distance_vehicule_personnel"] = distance_vehicule_personnel
                        }
                        body['organisations']["transport_en_commun"] = sessionStorage.getItem('organisationTransportCommun')
                        if(sessionStorage.getItem('organisationTransportCommun')==='Oui'){
                            let organisationTransportCommunDistance = JSON.parse(sessionStorage.getItem('organisationTransportCommunDistance'))
                            let distance_transport_en_commun = []
                            Object.keys(organisationTransportCommunDistance).forEach(element => {
                                let single_distance_transport_en_commun= {
                                    "type_de_vehicule": element,
                                    "distance": organisationTransportCommunDistance[element]
                                }
                                distance_transport_en_commun.push(single_distance_transport_en_commun)
                            })
                            body['organisations']["distance_transport_en_commun"] = distance_transport_en_commun
                        }
                        let organisationEnergie = JSON.parse(sessionStorage.getItem('organisationEnergie'))
                        let consommation_energetique = []
                        Object.keys(organisationEnergie).forEach(element => {
                                let single_consommation_energetique= {
                                    "type_de_vehicule": element,
                                    "distance": organisationEnergie[element]
                                }
                                consommation_energetique.push(single_consommation_energetique)
                            })
                    }
                }
                axios.post('https://3rdurable.org/wp-json/reponses-ges/v1/reponse-ges/', body).then((response) => {
                    if (response.status === 200) {
                        sessionStorage.setItem('uuid', uuidForm)
                    }
                }).catch(err => {
                    console.error(err)
                })
            }
        },
        convertUnit(number, unit){
            if(unit=== "pi²"){
                let result = number/ 10.764
                return result
            }
            else{
                return number
            }
        }
    },
    components: {
        HeaderResults,
        FooterResults,
        BodyResults
    },
    mounted() {
        this.result = this.calculateResults()
        this.sendData()
    }
}
</script>
<style scoped>
.w-70 {
    width: 60%;
}

.results-right-container {
    position: fixed;
    top: 0;
    height: 100vh;
    width: 40%;
    z-index: 1000;
    background-size: cover;
    right: 0;

}

.question-container {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.footer {
    margin-top: 20px;
}

@media screen and (max-width: 1520px) {
    .w-70 {
        width: 100%;
    }

    .results-right-container {
        display: none;
    }
    .tablette-background{
        height:500px;
        background-position: center;
        background-size:cover;
    }
}
@media screen and (max-width: 750px) {
    .mobile-background{
        height:200px;
        background-position: center;
        background-size:cover;
    }
    .tablette-background{
        display: none;
    }
}
@media (max-width: 576px) {
    .light-color-bg {
        padding-bottom:0;
    }
}
</style>